/**
 * Abre e fecha um popover preso a um botão: fecha ao clicar fora e com ESC
 * (devolvendo o foco ao botão, para quem usa teclado não se perder). O ESC
 * usado aqui fica marcado (`preventDefault`): não fecha também a conversa.
 */
import { useCallback, useEffect, useRef, useState } from "react";

export default function usePopover() {
  const [aberto, setAberto] = useState(false);
  const ancora = useRef(null);
  const gatilho = useRef(null);

  const fechar = useCallback((devolverFoco = false) => {
    setAberto(false);
    if (devolverFoco) gatilho.current?.focus?.();
  }, []);

  useEffect(() => {
    if (!aberto) return undefined;
    const aoClicarFora = (evento) => {
      if (ancora.current && !ancora.current.contains(evento.target)) setAberto(false);
    };
    const aoTeclar = (evento) => {
      if (evento.key !== "Escape") return;
      evento.preventDefault();
      fechar(true);
    };
    document.addEventListener("mousedown", aoClicarFora);
    document.addEventListener("keydown", aoTeclar);
    return () => {
      document.removeEventListener("mousedown", aoClicarFora);
      document.removeEventListener("keydown", aoTeclar);
    };
  }, [aberto, fechar]);

  return { aberto, alternar: () => setAberto((atual) => !atual), fechar, ancora, gatilho };
}
